import { usePathname, useRouter, useSearchParams } from "next/navigation";

export default function useAppSearchParams(key: string) {
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathName = usePathname();
  const value = searchParams.get(key);

  const setParam = (_value: string) => {
    const params = new URLSearchParams(searchParams.toString())
    params.set(key, _value);
    router.replace(`${pathName}?${params.toString()}`, { scroll: false });
  }

  const deleteParam = () => {
    const params = new URLSearchParams(searchParams.toString())
    params.delete(key);
    
    // router.replace(`${pathName}?${params.toString()}`, { scroll: false });
    router.replace(`${pathName}?${''}`, { scroll: false });
  }

  return {
    value,
    setParam,
    deleteParam
  }
}